import React, {useCallback, useContext} from 'react';
import {useSelector} from 'react-redux';


import {MessageContext} from 'src/contexts/message-context';
import {useEventTracking} from 'src/hooks/useEventTracking';
import {selectUserDetails} from 'src/modules/profile/user/services/user-page-slice';
import {getUserAuthenticationInfo} from 'src/openapi/admin/apis/UserAuthenticationInfoApi';
import {useAppDispatch} from 'src/store/hooks';

import Button from '@pb/kit-component-button';
import {Icon, Icons} from '@pb/kit-component-icon';
import {Tooltip} from '@pb/kit-component-popups';

import {useAssignGuid} from './useAssignGuid';

type Props = {
    userId: number,
};

export const AssignGuid = ({userId}: Props) => {
    const {authInfo} = useSelector(selectUserDetails);
    const apiDispatch = useAppDispatch();
    const {setSuccessMessage, setErrorMessage} = useContext(MessageContext);
    const {loginActionSubmit} = useEventTracking();

    const {event, busy: isUnlockBusy} = useAssignGuid({
        userId,
        onSuccess: () => {
            setSuccessMessage('Morningstar GUID has been assigned to this user.');
            loginActionSubmit({submit: true, success: true, itemAction: 'Assign GUID'});
            apiDispatch(getUserAuthenticationInfo({userId: +userId}));

        },
        onFail: (error: string) => {
            loginActionSubmit({submit: true, success: false, itemAction: 'Assign GUID'});
            setErrorMessage(error);
        },
    });

    const onAssignClick = useCallback(() => {
        event();
    }, [event]);

    if (!authInfo) {
        return null;
    }

    if (authInfo.error) {
        return (
            <Tooltip
                anchor={({anchorRef, getAnchorProps}) => (
                    <Button
                        ref={anchorRef}
                        {...getAnchorProps()}
                        startIcon={<Icon type={Icons.ERROR}/>}
                        variant="Type.SECONDARY"
                        disabled={true}>
                        Assign GUID
                    </Button>
                )}>
                {authInfo.error.message}
            </Tooltip>
        );
    }

    return (
        <Button
            busy={isUnlockBusy}
            disabled={!!authInfo?.data?.guid}
            variant="Type.SECONDARY"
            onClick={onAssignClick}>
            Assign GUID
        </Button>
    );
};
